<div *ngIf="productList as productListInvoiced else plpLoading">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
    </ng-template>

    <ng-template pTemplate="right">
      <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

      <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                pTooltip="Экспортировать информацию о товарах" tooltipPosition="top" [disabled]="!totalRecords"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table #prodTable
           [value]="productListInvoiced"
           [totalRecords]="totalRecords"
           [paginator]="true"
           [loading]="loading"
           [rows]="rows"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,20,50,100]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} товаров"
           selectionMode="single"
           [(selection)]="selectedProduct"
           dataKey="PRODID"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           [resizableColumns]="true"
           columnResizeMode="fit"
           filterDelay="500"
           rowExpandMode="single"
           sortField="PRODCODE">

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th pResizableColumn pSortableColumn="PRODCODE" style="width: 15%">Код <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODNAME" style="width: auto">Название <p-sortIcon field="PRODNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODVENDORNAME" style="width: auto">Поставщик <p-sortIcon field="PRODVENDORNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODGROUPNAME" style="width: auto">Группа <p-sortIcon field="PRODGROUPNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODSTOCK" style="width: 6%">Склад <p-sortIcon field="PRODSTOCK"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODSOLD" style="width: 6%">Продано <p-sortIcon field="PRODSOLD"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODRESERV" style="width: 6%">В резерве <p-sortIcon field="PRODRESERV"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODONHAND" style="width: 6%">В транзите <p-sortIcon field="PRODONHAND"></p-sortIcon></th>
      </tr>
      <tr>
        <th style="width: 3rem"></th>
        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по коду" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODCODE" (input)="prodTable.filter($event.target.value, 'PRODCODE', 'contains')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по названию" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODNAME" (input)="prodTable.filter($event.target.value, 'PRODNAME', 'contains')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по поставщику" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODVENDORNAME" (input)="prodTable.filter($event.target.value, 'PRODVENDORNAME', 'contains')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по группе" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODGROUPNAME" (input)="prodTable.filter($event.target.value, 'PRODGROUPNAME', 'contains')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск по cкладу" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODSTOCK" (input)="prodTable.filter($event.target.value, 'PRODSTOCK', 'gtOrZero')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск по проданному" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODSOLD" (input)="prodTable.filter($event.target.value, 'PRODSOLD', 'gtOrZero')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск по резерву" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODRESERV" (input)="prodTable.filter($event.target.value, 'PRODRESERV', 'gtOrZero')">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск по транзиту" class="p-dropdown-filter-style"
                   [(ngModel)]="filterPRODONHAND" (input)="prodTable.filter($event.target.value, 'PRODONHAND', 'gtOrZero')">
          </div>
        </th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-prod let-expanded="expanded">
      <tr [pSelectableRow]="prod" [class.complex]="(prod.PRODKIND==1)" [class.obsoleted]="(prod.PRODOBSOLETE == 1)" [class.onstock]="(prod.PRODSTOCK > 0)">
        <td style="width: 3rem">
          <button type="button" pButton pRipple pTooltip="Информация о резервировании"
                  [pRowToggler]="prod" class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </button>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <a [routerLink]="['/edit-product', prod.PRODID]">{{prod.PRODCODE}}</a>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.PRODNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.PRODVENDORNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.PRODGROUPNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.PRODSTOCK | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right"
            [class.ready]="((prod.PRODSOLD > 0) && (prod.PRODSTOCK >= prod.PRODSOLD))"
            [class.alarm]="(prod.PRODSTOCK + prod.PRODONHAND) < prod.PRODSOLD">
          {{prod.PRODSOLD | number:'1.0-2' }}
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.PRODRESERV | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.PRODONHAND | number:'1.0-2' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-prod>
      <tr>
        <td colspan="9">
            <app-product-reservation-table [prodId]="prod.PRODID"></app-product-reservation-table>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9">Нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #plpLoading>
  <p>Информация о товарах загружается...</p>
</ng-template>
